import React, { useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const PrivacyPolicy = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <main>
            <section className='cbp_layout_header'>
                <div className='container-fluid grey-border-b-1'>
                    <Header />
                </div>
            </section>

            <section className='section_padding cbp_layout_member'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-12 pt-md-4 pt-3'>
                            <h3 className='text-32 fw-bold text-center mb-0 m-md-3'>Privacy Policy</h3>

                            <div className='privacy-content terms-content'>
                                <p className='mb-4'>
                                    Catalyst Business Partners Pvt. Ltd. (“CBP”, “we”, “our”, or “us”) values your privacy and is
                                    committed to protecting the personal information shared with us through our website
                                    <a href="http://www.cbpgroup.in" className='text-decoration-none'> www.cbpgroup.in</a> and related services.
                                </p>
                                <p className='mb-5'>
                                    This Privacy Policy explains how we collect, use, disclose, and safeguard your information when
                                    you visit our website or become a member of CBP.
                                </p>

                                <div className='mb-4'>
                                    <h3 className='fw-bold mb-3'>1. Information We Collect</h3>
                                    <p>We may collect the following types of information:</p>

                                    <h5 className='fw-bold mt-3 mb-2'>a) Personal Information</h5>
                                    <ul className='list-unstyled ms-3'>
                                        <li>● Name</li>
                                        <li>● Email address</li>
                                        <li>● Phone number</li>
                                        <li>● City and country</li>
                                        <li>● Professional or business details</li>
                                        <li>● Any information voluntarily shared via forms, emails, or membership applications</li>
                                    </ul>

                                    <h5 className='fw-bold mt-3 mb-2'>b) Financial & Transactional Information</h5>
                                    <ul className='list-unstyled ms-3'>
                                        <li>● Membership payment details (processed via secure third-party payment gateways)</li>
                                        <li>● Transaction-related information linked to investment opportunities</li>
                                    </ul>
                                    <p className='mt-2 fst-italic'>Note: CBP does not store sensitive card or banking information on its servers.</p>

                                    <h5 className='fw-bold mt-3 mb-2'>c) Technical & Usage Information</h5>
                                    <ul className='list-unstyled ms-3'>
                                        <li>● IP address</li>
                                        <li>● Browser type</li>
                                        <li>● Device information</li>
                                        <li>● Pages visited and time spent on the website</li>
                                        <li>● Cookies and analytics data</li>
                                    </ul>
                                </div>

                                <div className='mb-4'>
                                    <h3 className='fw-bold mb-3'>2. How We Use Your Information</h3>
                                    <p>We use the collected information for the following purposes:</p>
                                    <ul className='list-unstyled ms-3'>
                                        <li>● To manage memberships and provide access to investment opportunities</li>
                                        <li>● To communicate deal updates, notifications, and service-related information</li>
                                        <li>● To process payments and maintain transaction records</li>
                                        <li>● To improve website performance and user experience</li>
                                        <li>● To comply with legal and regulatory obligations</li>
                                        <li>● To respond to queries, requests, or support needs</li>
                                    </ul>
                                </div>

                                <div className='mb-4'>
                                    <h3 className='fw-bold mb-3'>3. Cookies & Tracking Technologies</h3>
                                    <p>CBP may use cookies and similar technologies to:</p>
                                    <ul className='list-unstyled ms-3'>
                                        <li>● Analyze website traffic and usage patterns</li>
                                        <li>● Remember user preferences</li>
                                        <li>● Enhance website functionality</li>
                                    </ul>
                                    <p className='mt-2'>You may choose to disable cookies through your browser settings; however, some features of the website may not function optimally.</p>
                                </div>

                                <div className='mb-4'>
                                    <h3 className='fw-bold mb-3'>4. Sharing of Information</h3>
                                    <p>CBP does not sell or rent your personal information.</p>
                                    <p>We may share information only in the following circumstances:</p>
                                    <ul className='list-unstyled ms-3'>
                                        <li>● With trusted service providers (IT, payment gateways, communication platforms) strictly for operational purposes</li>
                                        <li>● When required by law, court order, or government authority</li>
                                        <li>● To protect CBP’s legal rights, prevent fraud, or ensure compliance with our Terms & Conditions</li>
                                    </ul>
                                </div>

                                <div className='mb-4'>
                                    <h3 className='fw-bold mb-3'>5. Confidentiality of Deal Information</h3>
                                    <p>All investment opportunities, reports, and materials shared with Members are confidential in nature. Members are expected to maintain confidentiality and not misuse or disclose such information without prior written consent from CBP.</p>
                                </div>

                                <div className='mb-4'>
                                    <h3 className='fw-bold mb-3'>6. Data Security</h3>
                                    <p>CBP implements reasonable administrative, technical, and organizational security measures to protect your personal data against unauthorized access, misuse, alteration, or disclosure. However, no method of transmission over the internet is completely secure, and CBP cannot guarantee absolute security.</p>
                                </div>

                                <div className='mb-4'>
                                    <h3 className='fw-bold mb-3'>7. Data Retention</h3>
                                    <p>We retain personal data only for as long as:</p>
                                    <ul className='list-unstyled ms-3'>
                                        <li>● The membership remains active</li>
                                        <li>● It is required to fulfill the purposes outlined in this policy</li>
                                        <li>● It is required under applicable laws</li>
                                    </ul>
                                    <p className='mt-2'>After this period, data is securely deleted or anonymized.</p>
                                </div>

                                <div className='mb-4'>
                                    <h3 className='fw-bold mb-3'>8. Your Rights</h3>
                                    <p>You have the right to:</p>
                                    <ul className='list-unstyled ms-3'>
                                        <li>● Request access to your personal information</li>
                                        <li>● Request correction of inaccurate data</li>
                                        <li>● Request deletion of your data (subject to legal and contractual obligations)</li>
                                        <li>● Withdraw consent for non-essential communications</li>
                                    </ul>
                                    <p className='mt-2'>Requests can be made by contacting us at the email address mentioned below.</p>
                                </div>

                                <div className='mb-4'>
                                    <h3 className='fw-bold mb-3'>9. Third-Party Links</h3>
                                    <p>Our website may contain links to third-party websites. CBP is not responsible for the privacy practices or content of such external websites. Users are encouraged to review the privacy policies of those websites independently.</p>
                                </div>

                                <div className='mb-4'>
                                    <h3 className='fw-bold mb-3'>10. Changes to This Privacy Policy</h3>
                                    <p>CBP reserves the right to modify or update this Privacy Policy at any time. Any changes will be posted on this page with an updated revision date. Continued use of the website constitutes acceptance of the updated policy.</p>
                                </div>

                                <div className='mb-4'>
                                    <h3 className='fw-bold mb-3'>11. Contact Us</h3>
                                    <p>For any questions, concerns, or requests related to this Privacy Policy, please contact:</p>
                                    <div className='mt-2'>
                                        <p className='fw-bold mb-1'>Catalyst Business Partners Pvt. Ltd.</p>
                                        <p className='mb-1'>✉ Email: <a href="mailto:info@cbpgroup.in" className='text-decoration-none'>info@cbpgroup.in</a></p>
                                        <p className='mb-0'>🌐 Website: <a href="http://www.cbpgroup.in" className='text-decoration-none'>www.cbpgroup.in</a></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className='cbp_layout footer-section'>
                <div className='container'>
                    <Footer />
                </div>
            </section>
        </main>
    );
};

export default PrivacyPolicy;
